import React from 'react';
import {useControllerProps, UseControllerPropsResult} from '../../../../../../domain/controllers/ControllerContext';
import {LineItemModel} from '../../../../../../domain/models/LineItems/LineItem.model';

export enum ItemLinkDataHooks {
  Anchor = 'ItemLinkDataHooks.Anchor',
  NonClickableItem = 'ItemLinkDataHooks.NonClickableItem',
}

const handleClick = ({
  event,
  navigationStore,
  fullUrl,
}: {
  event: React.MouseEvent<HTMLAnchorElement>;
  navigationStore: UseControllerPropsResult['navigationStore'];
  fullUrl: string;
}) => {
  event.preventDefault();
  event.stopPropagation();
  return navigationStore.navigateToUrl(fullUrl);
};

export const ItemLink = ({
  lineItem,
  children,
  tabIndex,
}: {
  lineItem: LineItemModel;
  children: React.ReactChild;
  tabIndex?: number;
}) => {
  const {navigationStore} = useControllerProps();
  const href = lineItem.attributes.url.url;

  if (!href) {
    return <div data-hook={ItemLinkDataHooks.NonClickableItem}>{children}</div>;
  }

  return (
    <a
      href={href}
      onClick={(event) =>
        handleClick({
          event,
          navigationStore,
          fullUrl: lineItem.attributes.url.url,
        })
      }
      {...(tabIndex !== undefined ? {tabIndex} : {})}
      data-hook={ItemLinkDataHooks.Anchor}>
      {children}
    </a>
  );
};
